import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedProduct } from "../../../types/productApiTypes";

interface CardBadgesProps {
  product: TransformedProduct;
}

const CardBadges: React.FC<CardBadgesProps> = ({ product }) => {
  const { t } = useTranslation();

  const showsPriceRange =
    product.type === "grouped" ||
    (product.isVariable && !product.hasDefaultVariation);

  // --- SMART LOGIC ---
  // 1. Check if stock is actually low (exists and not null).
  // 2. Check if product is technically in stock (not out of stock).
  // 3. EXCLUDE Variable products. We do not want to show "Only 2 left" on a card
  //    for a T-Shirt if only the "Small Red" is low stock. It is misleading.
  //    The default variation data is present in `product`, but we ignore it here for UX clarity.
  const isLowStock =
    product.lowStockRemaining !== null &&
    product.stockStatus === "instock" &&
    !product.isVariable;

  return (
    <div className="product-card__badges">
      {/* Low Stock Badge */}
      {isLowStock && (
        <span className="product-card__badge product-card__badge--low-stock">
          {t("productCard.lowStockBadge", {
            // Fix: Fallback to 0 if null to satisfy TS types, though logic ensures it's not null here
            count: product.lowStockRemaining ?? 0,
          })}
        </span>
      )}

      {/* Sale Badge */}
      {product.onSale && product.salePercentage > 0 && !showsPriceRange && (
        <span className="product-card__badge product-card__badge--sale">
          -{product.salePercentage}%
        </span>
      )}

      {/* Out of Stock Badge */}
      {product.stockStatus === "outofstock" && (
        <span className="product-card__badge product-card__badge--out-of-stock">
          {t("productCard.outOfStockBadge")}
        </span>
      )}
    </div>
  );
};

export default CardBadges;
